import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  message,
  Input,
  Button,
  Table,
  Modal,
  Spin,
  Typography,
  Tag,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  EditOutlined,
} from "@ant-design/icons";
import InitialPricesForm from "./initialPricesForm";
import axios from "axios";

const { Search } = Input;
const { Title } = Typography;

const InitialPrices = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [initialPricesData, setInitialPricesData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    fetchData();
  }, [submitted]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/initialPrices");
      setInitialPricesData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      message.error("Unable to load data!");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    const filtered = initialPricesData.filter((price) =>
      Object.keys(price).some((key) =>
        String(price[key]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleAddPrice = () => {
    setFormData({});
    setModalVisible(true);
  };

  const handleEditPrice = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <span>
          {searchQuery ? (
            <span
              style={{
                backgroundColor: "#fffb8f",
                fontWeight: "bold",
              }}
            >
              {text}
            </span>
          ) : (
            text
          )}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => `$${amount}`,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEditPrice(record)}
          style={{ color: "#0c8c49" }}
        >
          Edit
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Initial Prices
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col span={12}>
            <Search
              placeholder="Search Initial Prices"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddPrice}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add Initial Price
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 5 }}
            rowKey="id"
            bordered
          />
        )}
      </Card>

      <Modal
        title={formData.id ? "Edit Initial Price" : "Add Initial Price"}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        centered
        width="50%"
        style={{ borderRadius: "10px" }}
        bodyStyle={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <InitialPricesForm
          formData={formData}
          setFormData={setFormData}
          closeModal={() => setModalVisible(false)}
          setSubmitted={setSubmitted}
        />
      </Modal>
    </div>
  );
};

export default InitialPrices;
